// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:focus {
  outline: none;
}

.bookee-update-modal {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  z-index: 9999;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: row;
  background-color: rgba(0, 0, 0, 0.3);
  display: none;
}

.bookee-update-modal .modal-body {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
  padding: 18px;
  border-radius: 6px;
  margin-top: 16px;
}

@media screen and (max-width: 600px) {
  .bookee-update-modal .modal-body {
    width: 92%;
    padding: 24px 12px;
  }
}

.bookee-update-modal .modal-body .text-wrapper {
  display: flex;
  margin-right: 16px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  color: #000;
}

.bookee-update-modal .modal-body .text-wrapper .modal-header {
  margin-bottom: 4px;
  color: #0d1f2d;
  font-size: 18px;
  font-weight: bold;
}

.bookee-update-modal .modal-body .text-wrapper .modal-subheader {
  margin-bottom: 4px;
  color: #0d1f2d;
  font-size: 18px;
  font-weight: bold;
}

.bookee-update-modal .modal-body .text-wrapper .modal-subheader {
  color: #546a7b;
  font-size: 14px;
}

.bookee-update-modal .modal-body .btn-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.bookee-update-modal .modal-body .btn-wrapper button {
  padding: 12px 24px;
  color: #fff;
  font-weight: bold;
  border: none;
  background: #37b877;
  cursor: pointer;
  border-radius: 6px;
}

.bookee-update-modal .modal-body .btn-wrapper button:hover {
  background: #2e9b64;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[":focus {\n  outline: none;\n}\n\n.bookee-update-modal {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 9999;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  flex-direction: row;\n  background-color: rgba(0, 0, 0, 0.3);\n  display: none;\n}\n\n.bookee-update-modal .modal-body {\n  flex-direction: row;\n  display: flex;\n  justify-content: space-between;\n  background-color: #fff;\n  padding: 18px;\n  border-radius: 6px;\n  margin-top: 16px;\n}\n\n@media screen and (max-width: 600px) {\n  .bookee-update-modal .modal-body {\n    width: 92%;\n    padding: 24px 12px;\n  }\n}\n\n.bookee-update-modal .modal-body .text-wrapper {\n  display: flex;\n  margin-right: 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  color: #000;\n}\n\n.bookee-update-modal .modal-body .text-wrapper .modal-header {\n  margin-bottom: 4px;\n  color: #0d1f2d;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.bookee-update-modal .modal-body .text-wrapper .modal-subheader {\n  margin-bottom: 4px;\n  color: #0d1f2d;\n  font-size: 18px;\n  font-weight: bold;\n}\n\n.bookee-update-modal .modal-body .text-wrapper .modal-subheader {\n  color: #546a7b;\n  font-size: 14px;\n}\n\n.bookee-update-modal .modal-body .btn-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n}\n\n.bookee-update-modal .modal-body .btn-wrapper button {\n  padding: 12px 24px;\n  color: #fff;\n  font-weight: bold;\n  border: none;\n  background: #37b877;\n  cursor: pointer;\n  border-radius: 6px;\n}\n\n.bookee-update-modal .modal-body .btn-wrapper button:hover {\n  background: #2e9b64;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
